import { useFindActiveArrayFiltersForFacetName } from '@/features/shop/services/Search/hooks'
import { useFiltersContext } from '@/features/shop/components/ProductFilter/FiltersContext'
import { FilterPillContent } from '@/features/shop/components/ProductFilter/FilterOptions/FilterPillContent'
import { DISPLAY_FORMAT } from '@/features/shared/constants/analytics'
import { FilterScrollWrapper } from '@/features/shop/components/ProductFilter/FilterScrollWrapper'
import { useTrackFilterUtilityClicked } from '@/features/shared/analytics/filters'
import { type GeneralFacetItem } from '@/features/shop/services/Search/types'
import { PillFilterSection } from '@/features/shop/components/ProductFilter/PillFilterSection'
import { SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'

type Props = {
  name: string
  index: number
  items: GeneralFacetItem[]
}

export const BrandFilterOption = ({ name, index, items }: Props) => {
  const trackFilterUtilityClicked = useTrackFilterUtilityClicked()
  const { facets } = useFiltersContext()
  const findActiveFiltersForBrand = useFindActiveArrayFiltersForFacetName()
  const activeFilters = findActiveFiltersForBrand(facets, SEARCH_FILTER_TYPE.BRAND)
  const pillName = activeFilters[0] || name

  const handleOnClickFilter = () => {
    trackFilterUtilityClicked({
      list_index: index,
      utility_type: 'dropdown',
      filter_value: SEARCH_FILTER_TYPE.BRAND,
      filter_active: Boolean(activeFilters.length),
      display_format: DISPLAY_FORMAT.HORIZONTAL,
    })
  }

  return (
    <FilterScrollWrapper facet={SEARCH_FILTER_TYPE.BRAND} index={index} isDropdown>
      <FilterPillContent
        name={pillName}
        filterType={SEARCH_FILTER_TYPE.BRAND}
        onClick={handleOnClickFilter}
      >
        <PillFilterSection hideSearchInput items={items} name={SEARCH_FILTER_TYPE.BRAND} />
      </FilterPillContent>
    </FilterScrollWrapper>
  )
}
